<template>
  <div>
    <section class="orep-header mont">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img src="../../public/assets/images/logo@2.png" class="logo" alt="Logo">
        <span class="logo-text text-uppercase"></span>
      </section>
    </section>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="form-heading title-section auth-title-section form-section flex">
            <h1 class="form-title">Contact Us</h1>
          </article>

            <article class="auth-section">
              <p class="input-info">
                <i class="fas fa-exclamation-triangle not-eligible"></i><span class="not-eligible-text">
                  Email us at
                   <strong><a v-bind:href= "'mailto:'+ customerDetail.emailAddress" target="_top">{{ customerDetail.emailAddress }}</a></strong>
                </span>
              </p>
              <p>
                Hours: <strong>Monday – Friday from 7 am-5 pm PST</strong>
              </p>
              <p>
        <div class="col-md-12">
              <strong>We Answer the Phone!</strong>

              <ul >
                <li>

                  Phone: (888) 347-5273
                </li>
                <li>
                  Fax: (619) 704-0567
                </li>
                <li>
                  Fax (Alternate): (619) 269-3884.
                </li>
              </ul>
        </div>
              <p>
                <strong>
                  OREP Insurance Services,
                  </strong>LLC Calif. Lic. #0K99465
              </p>
              <p>
                6353 El Cajon Blvd, Suite 124-605
              </p>
              <p>
                San Diego, CA 92115
              </p>

            </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: "about",
    methods: {
      navigateToNext(routeName) {
        this.$router.push({
          name: routeName
        });
      },

      prev() {
        this.$router.push({
          name: "individual-appraiser-2"
        });
      },

      navigateToOne() {
        if (this.state.customerDetail.isGroupAppraiser) {
          this.$router.push({
            name: "group-appraiser-1"
          });
        }else if (this.state.customerDetail.isHomeInspector){
          this.$router.push({
            name: "property-inspector-1"

          });
        } else {
          this.$router.push({
            name: "individual-appraiser-1"

          });
        }

      },
    },
    computed: {
      customerDetail() {
        return this.$store.state.customerDetail;
      },
      state() {
        return this.$store.state.customerDetail;
      },
      errorMsg() {
        return this.$store.state.customerDetail.errorMsg;
      },

      mounted() {
        $('html, body').animate({
          scrollTop: $('.presentation-container').offset().top
        }, 500);
      },
    },
  }
</script>

<style scoped>
  .auth-section {
    max-width: 700px;
    display: flex;
    flex-direction: column;
    margin: 70px auto;
    padding: 1rem;
  }
  .action-btn {
    width: 230px;
    text-align: center;
    height: 46px;
    border-radius: 5px;
    background-color: #5f6273;
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
    border: 0;
    cursor: pointer;
    margin: 10px 0;
  }
  .user-info-row > div > p {
    font-weight: bold;
    font-size: 18px;
    text-decoration: underline;
  }
  .user-info-row > div {
    line-height: 24px;
  }
</style>
